import axios from "axios";

// get user ip for vdocipher watermark
export const getUserIp = async () => {
  // return await axios.get(`https://ipapi.co/json/`);
  return await axios.get(`https://api.ipify.org?format=json`);
};
